import { RefObject, useState } from "react";
import IAttachment from "../../../../models/IAttachment";
import "./AttachmentListItem.scss";
import { ConfirmDeleteOverlayFn } from "../../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";

type Props = {
    attachment: IAttachment;
    isReadOnly: boolean;
    downloadAttachment: (attachmentGuid: string) => void;
    deleteAttachment: (attachmentGuid: string) => void;
    nameOverride?: any; // allow strings or OwTranslate
};

type State = {
    showConfirmDelete: boolean;
    attachmentItemRef: RefObject<HTMLDivElement>;
};

export const AttachmentListItem = (props: Props) => {
    // overlayRef: any;
    //
    // readonly state: State = {
    //     showConfirmDelete: false,
    //     attachmentItemRef: createRef<HTMLDivElement>(),
    // };

    const [selectedElement, setSelectedElement] = useState<string | null>(null);

    const cancelConfirmDelete = () => {
        // setState({
        //     showConfirmDelete: false,
        // });
        setSelectedElement(null);
    };

    const showConfirmDelete = () => {
        // console.log("state.attachmentItemRef", state.attachmentItemRef);

        // setState({
        //     showConfirmDelete: true,
        // });
        setSelectedElement(`attachment-item-${props.attachment.guid}`);
    };

    const getDeleteConfirmOverlay = () => {
        // return (
        //     <div className={"position-absolute w-100 h-100 d-flex align-items-center ps-2 overlayRow"}>
        //         <span className={"me-2"}>
        //             <OwTranslate defaultMessage={"confirm_delete"} id={"confirm_delete"} />?{" "}
        //         </span>
        //         <div className="btn-group d-inline-flex">
        //             <button
        //                 type="button"
        //                 className="btn btn-danger btn-sm ms-2"
        //                 onClick={(e: any) => {
        //                     props.deleteAttachment(props.attachment.guid);
        //                 }}
        //                 title="Confirm Delete">
        //                 <i className="far fa-trash-alt" />
        //             </button>
        //             <button
        //                 type="button"
        //                 className="btn btn-secondary btn-sm"
        //                 onClick={(e: any) => {
        //                     cancelConfirmDelete();
        //                 }}
        //                 title="Cancel">
        //                 <i className="far fa-times" />
        //             </button>
        //         </div>
        //     </div>
        // );
    };

    const getActions = () => {
        let deleteAction: any = null;

        if (!props.isReadOnly) {
            deleteAction = (
                <i
                    className={"fa fa-trash-alt ms-2 me-2 pointer text-danger"}
                    onClick={(e: any) => {
                        showConfirmDelete();
                    }}
                />
            );
        }

        return (
            <span className={"actions"}>
                {deleteAction}

                <i
                    className={"fa fa-download ms-2 text-primary pointer"}
                    onClick={(e: any) => {
                        props.downloadAttachment(props.attachment.guid);
                    }}
                />
            </span>
        );
    };

    const getFileSize = (): string => {
        let units = "kb";
        const fileSize = props.attachment.size;
        let convertedFileSize = "0";

        if (fileSize) {
            if (fileSize / 1000 > 100) {
                units = "mb";

                convertedFileSize = (fileSize / 1000000).toFixed(2);
            } else {
                convertedFileSize = (fileSize / 1000).toFixed(2);
            }
        }

        return `${convertedFileSize} ${units}`;
    };
    const actions = getActions();

    let name = props.attachment.name;

    if (props.nameOverride) {
        name = props.nameOverride;
    }

    return (
        <div className="AttachmentListItem m-1 position-relative" id={"attachment-container-item-" + props.attachment.guid}>
            <ConfirmDeleteOverlayFn
                handleConfirm={() => {
                    props.deleteAttachment(props.attachment.guid);
                }}
                handleCancel={cancelConfirmDelete}
                message={"confirm_delete"}
                targetElem={selectedElement}
                leftAdjustment={0}
                skipMainView={true}
                nestedParentElem={`attachment-item-${props.attachment.guid}`}
                // nestedParentElem={"attachment-container-item-" + props.attachment.guid}
            />

            <div className={"p-2 rounded-5 name"} id={`attachment-item-${props.attachment.guid}`}>
                {actions} {name} <span className={"text-muted text-small"}>({getFileSize()})</span>
            </div>
        </div>
    );
};

export default AttachmentListItem;
